import React, { useCallback, useEffect, useState, FunctionComponent } from "react";
import { useFeatureFlagStore } from "../../../storez/FeatureFlagStore";
import ContentAwareConfigPage from "./index";
import ComponentLoading from "../../../modules/ComponentLoading";

import { useToast, useTranslation } from "@familyzone/component-library";
import type { ComponentProps } from "react";

type ContentAwareWrapperProps = ComponentProps<typeof ContentAwareConfigPage>;

const ContentAwareWrapper: FunctionComponent<ContentAwareWrapperProps> = (props) => {
  const { t } = useTranslation();
  const { errorToast } = useToast();
  const [fetching, setFetching] = useState<boolean>(true);

  const [featureFlags, getOrFetchFeatureFlags] = useFeatureFlagStore(useCallback((state) => [state.flags, state.getOrFetch] as const, []));

  useEffect(() => {
    let alive = true;

    void getOrFetchFeatureFlags()
      .catch((err: { message?: string }) => {
        errorToast({
          title: t("Please try again"),
          description: t(err?.message ?? "Failed to load feature flags."),
          isClosable: true,
        });
      })
      .finally(() => {
        if (alive) setFetching(false);
      });

    return () => {
      alive = false;
    };
  }, [getOrFetchFeatureFlags, errorToast, t]);

  if (!featureFlags && fetching) {
    return (
      <div className="centered">
        <ComponentLoading />
      </div>
    );
  }

  const textAnalysisFeatureEnabled = !!featureFlags?.["content-aware-text-analysis"];
  return <ContentAwareConfigPage textAnalysisFeatureEnabled={textAnalysisFeatureEnabled} {...props} />;
};

export default ContentAwareWrapper;
